//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";
export default {
  name: "SectionMunicipalityTopTitle",
  components: {
    Section: () => import("@/components/common/Section"),
    TopTitleComponent: () => import("@/components/common/TopTitleComponent")
  },
  computed: {
    ...mapGetters({
      title: 'municipality/title'
      }
    )
  }
};
